import ReactPixel from "react-facebook-pixel";
import * as firebase_analytics from "firebase/analytics";
import firebaseApp from "./firebaseApp";

const generalConsentCookie = "general_consent";
const pixelId = "371141030881918";

const firebaseAnalytics = firebase_analytics.getAnalytics(firebaseApp);

class Analytics {
  enabled: boolean = false;

  enable() {
    if (this.enabled) return;

    this.enabled = true;

    firebase_analytics.setAnalyticsCollectionEnabled(firebaseAnalytics, true);

    ReactPixel.init(pixelId, undefined, {
      autoConfig: true,
      debug: false,
    });
  }

  private logEvent(firebaseEvent: string, pixelEvent?: string) {
    if (!this.enabled) return;

    firebase_analytics.logEvent(firebaseAnalytics, firebaseEvent);

    if (pixelEvent) {
      ReactPixel.track(pixelEvent);
    }
  }

  logPageView(page: string) {
    if (!this.enabled) return;

    firebase_analytics.setCurrentScreen(firebaseAnalytics, page);

    ReactPixel.pageView();
  }

  logOpenAndroidStore(): void {
    this.logEvent("download_android", "SubmitApplication");
  }

  logOpenIOSStore(): void {
    this.logEvent("download_ios", "SubmitApplication");
  }

  logContact(): void {
    this.logEvent("contact_us", "Contact");
  }

  logVideoPlay(): void {
    this.logEvent("video_play");
  }

  logVideoPause(): void {
    this.logEvent("video_pause");
  }

  logVideoSeek(): void {
    this.logEvent("video_seek");
  }

  logOpenFacebook(): void {
    this.logEvent("open_facebook");
  }

  logOpenInstagram(): void {
    this.logEvent("open_instagram");
  }
}

const analytics = new Analytics();

export default analytics;
export { generalConsentCookie };
